export async function performFullLogout(redirectTo: string = "/sign-in") {
    // 1. Clear Web Storage
    try {
        localStorage.clear()
        sessionStorage.clear()
    } catch (err) {
        console.error("Failed to clear web storage:", err)
    }

    // 2. Clear all accessible cookies across sub-paths & current host
    try {
        const cookies = document.cookie.split(";")
        const host = window.location.hostname
        const domainParts = host.split(".")

        for (const cookie of cookies) {
            const eqPos = cookie.indexOf("=")
            const name = eqPos > -1 ? cookie.slice(0, eqPos).trim() : cookie.trim()
            if (!name) continue

            // Clear for current path
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;`

            // Clear across domain tiers (e.g. .rudrise.com, rudrise.com)
            for (let i = 0; i < domainParts.length - 1; i++) {
                const domain = domainParts.slice(i).join(".")
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.${domain};`
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${domain};`
            }
        }
    } catch (err) {
        console.error("Failed to clear cookies:", err)
    }

    // 3. Clear Cache Storage (Service Worker & assets cache)
    try {
        if ("caches" in window) {
            const cacheKeys = await window.caches.keys()
            await Promise.all(cacheKeys.map((key) => window.caches.delete(key)))
        }
    } catch (err) {
        console.error("Failed to clear caches:", err)
    }

    // 4. Clear IndexedDB databases
    try {
        if ("indexedDB" in window && indexedDB.databases) {
            const dbs = await indexedDB.databases()
            dbs.forEach((db) => {
                if (db.name) {
                    indexedDB.deleteDatabase(db.name)
                }
            })
        }
    } catch (err) {
        console.error("Failed to clear indexedDB:", err)
    }

    // 5. Force reload and redirect (clears in-memory React state)
    window.location.replace(redirectTo)
}